/* eslint-disable no-self-compare */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

const DeepLinkHandler = () => {
  const [searchParams] = useSearchParams();
  // const projectId = searchParams.get("projectId");
  const hiddenBtnRef = useRef < HTMLButtonElement | null > (null);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const isMobile = isIOS || isAndroid;
    const isDesktop = !isMobile;

    if (isDesktop) {
      window.location.href = "https://www.getsak.com/home";
      return;
    }

    if (isMobile && hiddenBtnRef.current) {
      hiddenBtnRef.current.click();
    }
  }, [searchParams]);

  const handleOpenApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    /*
    const deepLink = `sakapp://link?projectId=${projectId}`;
    window.location.href = deepLink;
    */
    setTimeout(() => {
      if (isIOS) {
        window.location.href = "https://app.adjust.com/17b556zr";
      } else if (isAndroid) {
        window.location.href = "https://app.adjust.com/17q1d5fo";
      } else {
        window.location.href = "https://www.getsak.com/home";
      }
    }, 1000);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h3>Redirecting...</h3>
      <p>Please wait while we redirect you to the app.</p>
      <button
        ref={hiddenBtnRef}
        onClick={handleOpenApp}
        style={{ display: "none" }}
      >
        Hidden Open App
      </button>
    </div>
  );
};

export default DeepLinkHandler;
